// extracted by mini-css-extract-plugin
export var cardTitle = "_iy-1";
export var commentBubble = "_iy-e";
export var commentForm = "_iy-a";
export var commentInput = "_iy-b";
export var commentLabel = "_iy-d";
export var commentPrompt = "_iy-9";
export var csatCard = "_iy-0";
export var feedbackSection = "_iy-7";
export var starDisabled = "_iy-6";
export var starEmpty = "_iy-5";
export var starFilled = "_iy-4";
export var starWrapper = "_iy-3";
export var starsContainer = "_iy-2";
export var submittedComment = "_iy-c";
export var thankYouText = "_iy-8";